import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { Layout, Menu, Dropdown, Icon, Button, Badge, Modal } from "antd";
import { bindActionCreators } from "redux";
import shortid from "shortid";
import moment from "moment";

import Ticket from "./ticket";

import { logout } from "../../Auth/actions";
import { axios, axiosPisCofins } from "../../../constants/axiosConfig";
import { ellipsisString } from "../../../helpers/functions";
import ModalHubSpot from "../../../components/ModalHubSpot";
import { useCallback } from "react";

const { Header } = Layout;

const HeaderComponent = (props) => {
  const [visible, setVisible] = useState(false);
  const [notificacoes, setNotificacoes] = useState([]);
  const [visivel, setVisivel] = useState(false);

  const aberturaTicketNovo = () => {
    return axiosPisCofins
      .get(`/Zendesk/ObterToken`)
      .then((response) => {

        if (response.status === 200) {
          let { TokenZendesk } = response.data;
          let url = `https://eauditoria.zendesk.com/access/jwt?jwt=${TokenZendesk}&return_to=https://eauditoria.zendesk.com/hc/pt-br/requests/new/`;

          window.open(
            url,
            "__blank"
          );
        }
      })
      .catch(() => {
        console.log("Erro ao acessar a URL de abertura de ticket");
        return [];
      });
  }

  const gestaoTicketsNovo = () => {
    return axiosPisCofins
      .get(`Zendesk/ObterToken`)
      .then((response) => {
        if (response.status === 200) {
          let { TokenZendesk } = response.data;
          let url = `https://eauditoria.zendesk.com/access/jwt?jwt=${TokenZendesk}&return_to=https://eauditoria.zendesk.com/hc/pt-br/requests`;

          window.open(
            url,
            "__blank"
          );
        }
      })
      .catch(() => {
        console.log("Erro ao acessar a URL de gestão de tickets");
        return [];
      });
  }

  const buscarNotificacao = useCallback(() => {
    const buscarNotificacaoContaUnica = () => {
      return axios
        .get(
          `${process.env.REACT_APP_CONTA_URL}/Notificacao/UltimasNotificacoes`,
          { params: { geral: true } }
        )
        .then((response) => {
          if (response.status === 200) {
            const aux = response.data.map((el) => ({
              ...el,
              dataPublicacao: converteDataNotificacao(el.dataPublicacao),
              svg:
                el.svg && el.svg.startsWith("/")
                  ? `${process.env.REACT_APP_CONTA_URL}/${el.svg}`
                  : el.svg,
            }));

            return aux;
          }
        })
        .catch(() => {
          console.log("Erro ao consultar o conta única sobre as notificações");
          return [];
        });
    };

    const buscarNotificacaoMultiplicador = () => {
      return axios
        .get(`${process.env.REACT_APP_MULTIPLICADOR_API_URL}/Notificacao`)
        .then((response) => {
          if (response.status === 200) {
            const aux = [
              ...response.data.resultados.map((x) => {
                return {
                  ...x,
                  origem: "eMultiplicador",
                  svg: "https://images.e-auditoria.com.br/global/favicon.png",
                  descMensagem: x.mensagem,
                  tipoNotificacao: x.titulo,
                  dataPublicacao: moment(x.dataCriacao).format(
                    "DD/MM/YYYY HH:mm"
                  ),
                };
              }),
            ];

            return aux;
          }
        })
        .catch(() => {
          console.log(
            "Erro ao consultar api do multiplicador sobre as notificações"
          );
          return [];
        });
    };

    Promise.all([
      buscarNotificacaoContaUnica(),
      buscarNotificacaoMultiplicador(),
    ]).then((arrayOfArrays) => {
      const notificacoes = [].concat.apply([], arrayOfArrays);
      setNotificacoes(notificacoes);
    });
  }, []);

  useEffect(() => {
    // Realiza a primeira busca de Notificações
    buscarNotificacao();

    // Agenda a busca a cada tantos milisegundos
    const interval = setInterval(() => {
      buscarNotificacao();
    }, 100000);

    // Cancela o agendamento da busca de notificação
    return () => clearInterval(interval);
  }, [buscarNotificacao]);

  const converteDataNotificacao = (dataPublicacao) => {
    var data = new Date(parseInt(dataPublicacao.match(/\d+/)[0]));
    var horas, minutos, dia, mes;

    if (data.getDate() < 10) dia = "0" + data.getDate();
    else dia = data.getDate();

    if (data.getMonth() + 1 < 10) mes = "0" + (data.getMonth() + 1);
    else mes = data.getMonth() + 1;

    if (data.getHours() < 10) horas = "0" + data.getHours();
    else horas = data.getHours();

    if (data.getMinutes() < 10) minutos = "0" + data.getMinutes();
    else minutos = data.getMinutes();

    return (
      dia + "/" + mes + "/" + data.getFullYear() + " " + horas + ":" + minutos
    );
  };

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const doClickNotificacao = (el) => {
    if (el.origem === "eMultiplicador") {
      Modal.info({
        title: el.titulo,
        content: (
          <span
            dangerouslySetInnerHTML={{
              __html: el.mensagem.replaceAll("<b>", "<br/><b>"),
            }}
          />
        ),
        onOk: () =>
          axios
            .put(
              `${process.env.REACT_APP_MULTIPLICADOR_API_URL}/Notificacao/${el.id}`
            )
            .then((response) => {
              if (response.status === 200) {
                const novaLista = [...notificacoes];
                const index = novaLista.findIndex(
                  (item) =>
                    item.id === el.id && item.origem === "eMultiplicador"
                );
                if (index >= 0) {
                  novaLista.splice(index, 1);
                  setNotificacoes(novaLista);
                }
              }
            })
            .catch(() => {
              console.log(
                "Erro ao consultar api do multiplicador sobre as notificações"
              );
              return [];
            }),
      });
    } else {
      window.open(
        `${process.env.REACT_APP_CONTA_URL}/Notificacao?id=${el.idNotificacao}&origem=${el.origem}`,
        "__blank"
      );
    }
  };

  const history = useHistory();

  return (
    <>
      <Ticket visible={visible} onClose={onClose} />
      <ModalHubSpot visivel={visivel} setVisivel={setVisivel} titulo="Descubra como a nova e-Auditoria pode transformar seu escritório" />

      <Header className="navbar no-print">
        <Link className="logo" to="/bemvindo">
          <img
            className="navbar__logo"
            src="https://images.e-auditoria.com.br/global/logos/png/erecuperador.png"
            alt="e-Recuperador"
          />
        </Link>

        <Menu mode="horizontal">
          <Icon
            title="Arquivo"
            component={() => <i className="fas fa-2x fa-archive" />}
            onClick={() => history.push("/bemvindo/arquivado")}
          />
          <Dropdown
            overlay={
              <div className="submenu">
                <h5 className="submenu__title">Produtos</h5>

                <div className="submenu__products">
                  <a
                    className="submenu__products___item"
                    href="https://eauditor-cloud.e-auditoria.com.br/inicioV2"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/eauditor-mini.svg"
                      alt="e-Auditor"
                    />
                    <span className="item__name">e-Auditor</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href="https://esimulador.e-auditoria.com.br"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/esimulador-mini.svg"
                      alt="e-Simulador"
                    />
                    <span className="item__name">e-Simulador</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href="https://econsulta.e-auditoria.com.br"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/econsulta-mini.svg"
                      alt="e-Consulta"
                    />
                    <span className="item__name">e-Consulta</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href="https://edrive.e-auditoria.com.br"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/edrive-mini.svg"
                      alt="e-Drive"
                    />
                    <span className="item__name">e-Drive</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href={`${process.env.REACT_APP_CONTA_URL}/ecapturador`}
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/ecapturador-mini.svg"
                      alt="e-Capturador"
                    />
                    <span className="item__name">e-Capturador</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href={`${process.env.REACT_APP_CONTA_URL}/eatendimento`}
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/eatendimento-mini.svg"
                      alt="e-Atendimento"
                    />
                    <span className="item__name">e-Atendimento</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href="/bemvindo"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/erecuperador-mini.svg"
                      alt="e-Recuperador"
                    />
                    <span className="item__name">e-Recuperador</span>
                  </a>

                  <a
                    className="submenu__products___item"
                    href="https://emonitor.e-auditoria.com.br"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="item__logo"
                      src="https://images.e-auditoria.com.br/global/logos/svg/emonitor-mini.svg"
                      alt="e-Monitor"
                    />
                    <span className="item__name">e-Monitor</span>
                  </a>
                </div>
              </div>
            }
          >
            <Icon component={() => <i className="fas fa-2x fa-th-large" />} />
          </Dropdown>

          <Dropdown
            overlay={
              <div className="submenu">
                <ul className="submenu__attendance">
                  <h5 className="submenu__title">e-Atendimento</h5>
                  <li
                    className="submenu__attendance___item"
                    onClick={aberturaTicketNovo}
                  >
                    Abertura de ticket
                  </li>
                  <li
                    className="submenu__attendance___item"
                    onClick={gestaoTicketsNovo}
                  >
                    Gestão de tickets
                  </li>
                  <li
                    className="submenu__attendance___item"
                    onClick={() => setVisivel(true)}
                  >
                    Solicitar Upgrade
                  </li>
                  <li className="submenu__attendance___item">
                    <a
                      href="http://e-auditoria.com.br/faq"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      FAQ
                    </a>
                  </li>
                  <li className="submenu__attendance___item">
                    <a
                      href={`${process.env.REACT_APP_CONTA_URL}/Home/Manual`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Manual
                    </a>
                  </li>
                  <li className="submenu__attendance___item">
                    <a
                      href="http://e-auditoria.com.br/materiais-educacionais"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Materiais educacionais
                    </a>
                  </li>
                  <li className="submenu__attendance___item">
                    <a
                      href="https://convenios.e-auditoria.com.br/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Convênios e Benefícios
                    </a>
                  </li>
                </ul>
              </div>
            }
          >
            <Icon
              component={() => <i className="fas fa-2x fa-question-circle" />}
            />
          </Dropdown>

          <Dropdown
            overlay={
              <div className="submenu">
                <h5 className="submenu__title">Notificações</h5>

                <div className="submenu__notification">
                  <div
                    className={`submenu__notification___empty ${notificacoes.length !== 0 ? "d-none" : ""
                      }`}
                  >
                    <h5>
                      <i className="fa fa-bell-slash fa-lg" />
                    </h5>
                    <span className="empty__caption">Não há notificações</span>
                  </div>

                  {notificacoes &&
                    notificacoes.map((el) => {
                      return (
                        // eslint-disable-next-line
                        <a
                          key={`notificacao-${shortid.generate()}`}
                          className="submenu__notification___item"
                          onClick={() => doClickNotificacao(el)}
                          href="#"
                        >
                          <div className="item__icon">
                            {el.svg ? (
                              <img alt="Logo produto" src={el.svg} />
                            ) : (
                              <i className="fa fa-bell" />
                            )}
                          </div>

                          <div className="item__caption">
                            <h5 className="item__caption___title">
                              {el.tipoNotificacao}
                            </h5>
                            <p
                              className="item__caption___intro"
                              dangerouslySetInnerHTML={{
                                __html: ellipsisString(el.descMensagem, 120),
                              }}
                            />
                            <span className="item__caption___data">
                              {el.dataPublicacao}
                            </span>
                          </div>
                        </a>
                      );
                    })}

                  <a
                    className="submenu__notification___link"
                    href={`${process.env.REACT_APP_CONTA_URL}/Notificacao`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <div>Ver mais</div>
                  </a>
                </div>
              </div>
            }
          >
            <Badge
              className="blink"
              count={notificacoes.length}
              overflowCount={5}
            >
              <Icon component={() => <i className="fas fa-2x fa-bell" />} />
            </Badge>
          </Dropdown>

          <Dropdown
            overlay={
              <div className="submenu submenu__profile">
                <div className="submenu__profile___body">
                  <div className="body__icon">
                    {sessionStorage.LogoEmpresa ? (
                      <img
                        alt="logo empresa"
                        src={`data:image;base64, ${sessionStorage.LogoEmpresa}`}
                      />
                    ) : (
                      <Icon type="user" icon="" />
                    )}
                  </div>

                  <div className="body__caption">
                    <span className="body__caption___email">
                      {window.atob(sessionStorage.getItem("Login"))}
                    </span>
                    <a
                      className="btn btn-sm btn-primary body__caption___btn"
                      href={`${process.env.REACT_APP_CONTA_URL}/Perfil`}
                      rel="noopener noreferrer"
                    >
                      Minha conta
                    </a>
                  </div>
                </div>

                <div className="submenu__profile___footer">
                  {sessionStorage.IsAdmin ? (
                    <a
                      className="btn btn-sm btn-outline-dark"
                      href={`${process.env.REACT_APP_CONTA_URL}/Faturamento`}
                      rel="noopener noreferrer"
                    >
                      Faturamento
                    </a>
                  ) : (
                    <span />
                  )}
                  <Button
                    className="btn btn-sm btn-outline-dark"
                    onClick={props.logout}
                  >
                    Sair
                  </Button>
                </div>
              </div>
            }
          >
            <Icon
              component={() => <i className="fas fa-2x fa-user-circle" />}
            />
          </Dropdown>
        </Menu>
      </Header>
    </>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout }, dispatch);

export default connect(null, mapDispatchToProps)(HeaderComponent);
